// extracted by mini-css-extract-plugin
export default {"page":"SetupContent_page__K2yAw","content":"SetupContent_content__KV5v1","cardContent":"SetupContent_cardContent__fyKuG"};